function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M30.833 36.667h-30A.836.836 0 010 35.833V4.167c0-.459.375-.834.833-.834h30c.459 0 .834.375.834.834v31.666a.836.836 0 01-.834.834zM1.667 35H30V5H1.667v30z",
  fill: "#262626"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.167 40h-30a.836.836 0 01-.833-.833c0-.459.374-.834.833-.834h29.166V7.5c0-.458.376-.833.834-.833.458 0 .833.375.833.833v31.667a.836.836 0 01-.833.833z",
  fill: "#262626"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.833 11.667h-30A.836.836 0 010 10.833C0 10.375.375 10 .833 10h30c.459 0 .834.375.834.833a.836.836 0 01-.834.834zM7.5 6.667a.836.836 0 01-.833-.834v-5C6.667.375 7.042 0 7.5 0c.458 0 .833.375.833.833v5a.836.836 0 01-.833.834zM24.167 6.667a.836.836 0 01-.834-.834v-5c0-.458.376-.833.834-.833.458 0 .833.375.833.833v5a.836.836 0 01-.833.834zM14.742 26.583L14.117 14.6h3.433l-.625 11.983h-2.183zM15.842 28.325h-.009c-.998 0-1.808.81-1.808 1.809v.125c0 .998.81 1.808 1.808 1.808h.009c.998 0 1.808-.81 1.808-1.808v-.125c0-1-.81-1.809-1.808-1.809z",
  fill: "#262626"
});

function SvgAvailability(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgAvailability;